<template>
  <div class="col-xxl-5 col-xl-4 col-sm-6 box-col-30">
    <div class="card best-sellers">
      <div class="card-header pb-0">
        <h3> Best Sellers</h3>
      </div>
      <div class="card-body">
        <div class="table-responsive theme-scrollbar">
          <table class="table table-bordernone">
            <thead>
              <tr>
                <th>Name</th>
                <th>Date</th>
                <th>Product</th>
                <th>Total</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in table" :key="item">
                <td>
                  <div class="d-flex">
                    <div class="icon"><img class="img-fluid" :src="getImageUrl(item.img)" alt="person1"></div>
                    <div class="flex-grow-1"><router-link to="/users/profile">
                        <h5>{{ item.name }}</h5>
                      </router-link>
                      <p>{{ item.year }}</p>
                    </div>
                  </div>
                </td>
                <td>
                  <h5>{{ item.date }}</h5>
                </td>
                <td>
                  <h5>{{ item.product }}</h5>
                </td>
                <td>
                  <h5>{{ item.total }}</h5>
                </td>
                <td>
                  <div class="status-showcase">
                    <p>{{ item.width }}</p>
                    <div class="progress " :class="item.class" style="height: 5px;">
                      <div class="progress-bar" role="progressbar" :style="{ 'width': item.width }" aria-valuenow="50"
                        aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import tables from "@/data/tables"
import getImage from "@/mixins/getImage"
export default {
  mixins: [getImage],
  name: 'bestsellerPage',
  data() {
    return {
      table: tables.sell
    }
  }
}
</script>